var React = require('react');

function Dollar (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M11.748 19.501V22M11.748 2v2.503M8 15.752c0 2.068 1.678 3.749 3.748 3.749 2.07 0 3.751-1.68 3.751-3.749 0-2.074-1.68-3.753-3.75-3.753C9.678 12 8 10.32 8 8.252c0-2.074 1.678-3.748 3.748-3.748 2.07 0 3.751 1.674 3.751 3.748"}));
}

Dollar.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = Dollar;

Dollar.default = Dollar;
